import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import { ITareWeightPercentagesState } from 'src/common/interfaces/states/ITareWeightPercentageState';

const initialState: ITareWeightPercentagesState = {};

class TareWeightPercentagesReducer extends ImmerReducer<ITareWeightPercentagesState> {
  public addTareWeightPercentage(itemId: string, tarePercentage: number[]): void {
    if (!this.draftState[itemId]) {
      this.draftState[itemId] = { tarePercentage };
    }
  }

  public resetTareWeightPercentages() {
    this.draftState = initialState;
  }
}

export const TareWeightPercentagesActions = createActionCreators(TareWeightPercentagesReducer);
export const TareWeightPercentagesReducerFunction = createReducerFunction(
  TareWeightPercentagesReducer,
  initialState,
);
